import { UI_LANGUAGE_QUERY_PARAM_MAP, UiLanguage } from 'admin-panel/constants';

const isUiLanguageQueryParam = (
  value: string
): value is keyof typeof UI_LANGUAGE_QUERY_PARAM_MAP =>
  value in UI_LANGUAGE_QUERY_PARAM_MAP;

export const resolveUiLanguageQueryParam = (
  languageQueryParam: string | undefined
) => {
  const normalizedLanguageQueryParam = languageQueryParam?.trim().toLowerCase();

  if (
    normalizedLanguageQueryParam &&
    isUiLanguageQueryParam(normalizedLanguageQueryParam)
  ) {
    return UI_LANGUAGE_QUERY_PARAM_MAP[normalizedLanguageQueryParam];
  }

  return undefined;
};

export const resolveUiLanguage = (
  languageQueryParam: string | undefined,
  fallbackLanguage: UiLanguage
) => {
  return resolveUiLanguageQueryParam(languageQueryParam) ?? fallbackLanguage;
};
